import ApiCollection                from '@widesk-core/models/ApiCollection';
import { Box }                      from '@chakra-ui/react';
import CodeInformation              from '@/pages/Ticket/components/CodeInformation';
import CodeModel                    from '@/models/services/code/CodeModel';
import CodePropertyValueModel       from '@/models/services/code/CodePropertyValueModel';
import QRCodeRow                    from './QRCodeRow';
import { Separator }                from '@chakra-ui/react';
import FondationsEntertainmentModel from '@/models/services/fondations/EntertainmentModel';
import CodeTypePropertyValueModel   from '@/models/services/code/CodeTypePropertyValueModel';

interface ITicketPageBoxProps {
	code: CodeModel;
	codePropertyValueCollection: ApiCollection<CodePropertyValueModel>;
	codeTypePropertyValueCollection: ApiCollection<CodeTypePropertyValueModel>;
	gespassEntertainment: FondationsEntertainmentModel | undefined;
}

const TicketPageBox = (props: ITicketPageBoxProps) => {

	const { code, codePropertyValueCollection, codeTypePropertyValueCollection, gespassEntertainment } = props;

	return (
		<Box
			display="flex"
			flexDirection="column"
			bg="white"
			rounded="md"
			shadow="md"
			padding="30px"
			gap="20px"
			overflow="auto"
		>
			<QRCodeRow code={code} gespassEntertainment={gespassEntertainment} />
			{
				(codePropertyValueCollection.length > 0 || codeTypePropertyValueCollection.length > 0) &&
				<>
					<Separator />
					<CodeInformation
						code={code}
						codePropertyValueCollection={codePropertyValueCollection}
						codeTypePropertyValueCollection={codeTypePropertyValueCollection}
					/>
				</>
			}
		</Box>
	)
}

export default TicketPageBox